import { Component } from '@angular/core';

@Component({
    selector: 'baas-icon-text-table, baas-field-table',
    templateUrl: './baas-field-table.html',
    host: { class: 'lv-field-table' }
})
export class BaasFieldTable {}

/** @deprecated Use BaasFieldTable instead. */
export { BaasFieldTable as BaasIconTextTable };
